module.exports = __webpack_public_path__ + "img/device-Information_2_v1.61f54877.png";